import { bodyTextColor } from './BodyTextStore';

import { bodyTextColorDefault } from './BodyTextStoreDefaults';

export const resetBodyTextColor = () => bodyTextColor.set(bodyTextColorDefault);
